import {prop} from 'ramda';

import {DASHBOARD_TILE_SIZES} from '../consts/dashboardTileSizes';
import {DashboardTileSize} from '../types/DashboardTileSize';

// The wire format is `<columns>x<rows>` in grid units of the arrangement it is stored with.
export const toDashboardTileSizeCode = (size: DashboardTileSize) => {
  const {columns, rows} = prop(size, DASHBOARD_TILE_SIZES);

  return `${columns}x${rows}`;
};
